import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="var(--dataviz-color-sequential-blue-scale03)"
      fillRule="evenodd"
      d="M3 14.05c0-.58.47-1.05 1.05-1.05 5.43 0 9.437 1.085 13.225 2.138l.226.063C21.2 16.231 24.684 17.2 29.25 17.2a1.05 1.05 0 1 1 0 2.1c-4.856 0-8.578-1.036-12.253-2.06l-.285-.078C12.95 16.115 9.176 15.1 4.05 15.1c-.58 0-1.05-.47-1.05-1.05"
      clipRule="evenodd"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale05)"
      fillRule="evenodd"
      d="M30.3 7.05c0-.58-.47-1.05-1.05-1.05-3.128 0-5.432.708-7.612 2.142-2.094 1.377-4.054 3.419-6.51 5.978l-.075.078C10.198 19.253 6.268 20 4.05 20a1.05 1.05 0 0 0 0 2.1c2.822 0 7.29-1.003 12.517-6.448 2.549-2.654 4.35-4.523 6.225-5.756C24.602 8.705 26.498 8.1 29.25 8.1c.58 0 1.05-.47 1.05-1.05"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLine;
